import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=71717f47&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=71717f47&prod&lang=scss"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=71717f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71717f47",
  null
  
)

export default component.exports